import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TransportRouteRole } from '../../../../../generated/generated-types';
import { AddressTransportRoutesWidgetComponent } from './address-transport-routes-widget.component';

/**
 * Formly host of the "Transportwege" tab on the address page: one table per side the address has – vendor
 * (Kreditor) and customer (Debitor); an address that is both shows both.
 */
@Component({
  selector: 'app-formly-address-transport-routes',
  template: `
    <div class="flex flex-col gap-6 p-2">
      @if (model?.isCreditor) {
        <app-address-transport-routes-widget [addressId]="model.id" [role]="roles.CREDITOR" [currency]="model.creditor?.currency" />
      }
      @if (model?.isDebitor) {
        <app-address-transport-routes-widget [addressId]="model.id" [role]="roles.DEBITOR" [currency]="model.debitor?.currency" />
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AddressTransportRoutesWidgetComponent],
})
export class FormlyAddressTransportRoutesComponent extends FieldType {
  readonly roles = TransportRouteRole;
}
